module.exports = __webpack_public_path__ + "img/img.cc965174.jpg";